module.exports = __webpack_public_path__ + "static/media/swish.816dcb37.svg";